import React from 'react';
import ConfirmationModal from './ConfirmationModal';

export const BulkDeleteConfirmationModal = ({
  show,
  onHide,
  onConfirm,
  selectedCount,
  isDeleting = false
}) => {
  return (
    <ConfirmationModal
      show={show}
      onHide={onHide}
      onConfirm={onConfirm}
      title="Delete Multiple Recipes"
      message={
        <>
          <p>Are you sure you want to delete <strong>{selectedCount} recipes</strong>?</p>
          <p className="text-warning mb-0">
            <i className="fas fa-exclamation-triangle me-2"></i>
            This will also remove their ingredients from your shopping list.
          </p>
        </>
      }
      confirmText={`Delete ${selectedCount} Recipes`}
      confirmVariant="danger"
      icon="fas fa-trash"
      isProcessing={isDeleting}
      processingText="Deleting..."
    />
  );
};

export const ClearDayConfirmationModal = ({
  show,
  onHide,
  onConfirm,
  day,
  recipeCount,
  isClearing = false,
  currentPlanType = 'current'
}) => {
  return (
    <ConfirmationModal
      show={show}
      onHide={onHide}
      onConfirm={onConfirm}
      title={`Clear ${day}`}
      message={
        <>
          <p>Are you sure you want to clear all recipes from <strong>{day}</strong>?</p>
          <p>
            This will remove <strong>{recipeCount} recipes</strong>
            {currentPlanType === 'current' && ' and their ingredients from your shopping list'}.
          </p>
        </>
      }
      confirmText="Clear Day"
      confirmVariant="danger"
      icon="fas fa-trash-alt"
      isProcessing={isClearing}
      processingText="Clearing..."
    />
  );
};

export const ClearMealConfirmationModal = ({
  show,
  onHide,
  onConfirm,
  day,
  meal,
  recipeCount,
  isClearing = false,
  currentPlanType = 'current'
}) => {
  return (
    <ConfirmationModal
      show={show}
      onHide={onHide}
      onConfirm={onConfirm}
      title={`Clear ${meal} on ${day}`}
      message={
        <>
          <p>Are you sure you want to clear all <strong>{meal}</strong> recipes from <strong>{day}</strong>?</p>
          <p>
            This will remove <strong>{recipeCount} recipes</strong>
            {currentPlanType === 'current' && ' and their ingredients from your shopping list'}.
          </p>
        </>
      }
      confirmText="Clear Meal"
      confirmVariant="warning"
      icon="fas fa-times"
      isProcessing={isClearing}
      processingText="Clearing..."
    />
  );
};

export const DuplicateWeekConfirmationModal = ({
  show,
  onHide,
  onConfirm,
  isDuplicating = false
}) => {
  return (
    <ConfirmationModal
      show={show}
      onHide={onHide}
      onConfirm={onConfirm}
      title="Duplicate Week's Plan"
      message={
        <>
          <p>This will copy all recipes from the current week to next week.</p>
          <p className="text-info mb-0">
            <i className="fas fa-info-circle me-2"></i>
            Any existing recipes in next week will be preserved.
          </p>
        </>
      }
      confirmText="Duplicate to Next Week"
      confirmVariant="primary"
      icon="fas fa-copy"
      isProcessing={isDuplicating}
      processingText="Duplicating..."
    />
  );
};

export const ClearAllDaysConfirmationModal = ({
  show,
  onHide,
  onConfirm,
  totalRecipeCount,
  isClearing = false,
  currentPlanType = 'current'
}) => {
  return (
    <ConfirmationModal
      show={show}
      onHide={onHide}
      onConfirm={onConfirm}
      title="Clear All Days"
      message={
        <>
          <p>Are you sure you want to clear all recipes from the entire week?</p>
          <p className="text-danger">
            <i className="fas fa-exclamation-triangle me-2"></i>
            This will remove <strong>{totalRecipeCount} recipes</strong> from all days
            {currentPlanType === 'current' && ' and their ingredients from your shopping list'}.
          </p>
          <p className="text-muted small mb-0">This action cannot be undone.</p>
        </>
      }
      confirmText="Clear All Days"
      confirmVariant="danger"
      icon="fas fa-trash-alt"
      isProcessing={isClearing}
      processingText="Clearing..."
    />
  );
};